import React from 'react'
import styled from 'styled-components'
import { StaticImage } from 'gatsby-plugin-image'

const HomeIntro = () => {
  return (
    <Wrapper>
      <Container>
        <StaticImage
          className="tape"
          imgClassName="tape-image"
          src="../assets/images/tape-cropped.webp"
          alt=""
          loading="lazy"
          layout="constrained"
        />
        <Text className="home-intro-text">
          <h2>Remember these things?</h2>
          <p>
            You don’t need to be a tape trader to relive your childhood. Thanks
            to the marvels of modern technology, your favourite moments in
            wrestling history are more accessible than ever. The{' '}
            <em>Retro Wrestling Archive</em> exists to provide an acute dose of
            nostalgia.
          </p>

          <p>
            Find official links to stream events on Peacock (US) or the WWE
            Network (International). Listen to podcasts detailing all the
            behind-the-scenes info. Learn about the matches you didn’t even know
            happened.
          </p>
        </Text>
      </Container>
    </Wrapper>
  )
}

const Wrapper = styled.section`
  position: relative;
`

const Container = styled.div`
  max-width: var(--max-width);
  margin: 0 auto;
  padding: var(--size-16) var(--padding-x);

  display: grid;
  grid-template-columns: var(--grid-columns);
  grid-template-rows: auto;
  justify-items: center;
  align-content: center;

  @media (min-width: 480px) {
  }

  @media (min-width: 768px) {
  }

  @media (min-width: 1024px) {
  }

  .tape {
    grid-column: 1 / -1;
    grid-row: 1 / 2;
    max-width: 50ch;
    width: 100%;
    height: 100%;
    align-self: center;

    @media (min-width: 480px) {
    }

    @media (min-width: 768px) {
      grid-column: 1 / 8;
      grid-row: 1 / 2;
      max-width: unset;
    }

    @media (min-width: 1024px) {
    }
  }
`

const Text = styled.div`
  align-self: center;
  justify-self: start;
  grid-column: 1 / -1;
  grid-row: 2 / 3;
  margin-top: var(--size-8);
  margin-left: auto;
  margin-right: auto;

  @media (min-width: 480px) {
  }

  @media (min-width: 768px) {
    grid-column: 9 / -1;
    grid-row: 1 / 2;
  }

  @media (min-width: 1024px) {
  }

  h2 {
    font-family: var(--font-display);
    text-transform: uppercase;
    font-size: var(--font-size-7);
    line-height: var(--font-lineheight-7);
    text-align: center;

    @media (min-width: 768px) {
      font-size: var(--font-size-8);
      line-height: var(--font-lineheight-8);
      text-align: left;
    }
  }

  p {
    max-width: 50ch;
    font-size: var(--font-size-1);
    line-height: var(--font-lineheight-1);
    text-align: center;

    &:not(:last-child) {
      margin: 1em 0;
    }

    @media (min-width: 768px) {
      font-size: var(--font-size-2);
      line-height: var(--font-lineheight-2);
      text-align: left;
    }

    @media (min-width: 1024px) {
    }
  }

  em {
    font-style: normal;
    font-weight: 600;
    /* color: var(--color-primary); */
  }
`

export default HomeIntro
